import React, { useState } from "react";
import { useNavigate, useSearchParams, Link } from "react-router-dom";
import { toast } from "sonner";
import AuthLayout from "./AuthLayout";
import { useAuth } from "../context/AuthContext";
import { ROLE_HOME } from "../lib/api";
import { useT, localizeError } from "../components/home/i18n";

export default function VerifyEmail() {
  const { verifyEmail, resendOtp } = useAuth();
  const { t } = useT();
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const email = params.get("email") || "";
  const [code, setCode] = useState(params.get("code") || "");
  const [loading, setLoading] = useState(false);
  const c = t.auth.verify;

  const doVerify = async (theCode) => {
    setLoading(true);
    try {
      const user = await verifyEmail(email, theCode);
      toast.success(c.verified);
      navigate(ROLE_HOME[user.role] || "/");
    } catch (err) {
      toast.error(localizeError(err.response?.data?.detail, t));
    } finally {
      setLoading(false);
    }
  };

  const submit = (e) => { e.preventDefault(); doVerify(code); };

  const resend = async () => {
    try { await resendOtp(email); toast.success(c.resent); }
    catch (err) { toast.error(localizeError(err.response?.data?.detail, t)); }
  };

  const subtitle = email ? c.subWith.replace("{email}", email) : c.subNo;

  return (
    <AuthLayout testid="verify-page" title={c.title} subtitle={subtitle}>
      <form onSubmit={submit} className="space-y-4">
        <div>
          <label className="text-xs font-medium text-[#5C5855]">{c.codeLabel}</label>
          <input data-testid="verify-code" value={code} onChange={(e) => setCode(e.target.value.replace(/\D/g, "").slice(0, 6))}
            inputMode="numeric" placeholder="000000" required
            className="mt-1 w-full rounded-sm border border-[#E8E4DB] bg-white px-3 py-3 text-center text-2xl tracking-[0.5em] outline-none focus:border-[#1F4A38] focus:ring-1 focus:ring-[#1F4A38]" />
        </div>
        <button data-testid="verify-submit" disabled={loading || code.length !== 6}
          className="w-full rounded-full bg-[#1F4A38] py-3 text-sm font-semibold text-white transition-opacity hover:opacity-90 disabled:opacity-60">
          {loading ? c.submitting : c.submit}
        </button>
        <div className="flex items-center justify-between text-sm">
          <button type="button" data-testid="verify-resend" onClick={resend} className="font-semibold text-[#1F4A38]">{c.resend}</button>
          <Link to="/login" className="text-[#5C5855]">{c.back}</Link>
        </div>
      </form>
    </AuthLayout>
  );
}
